<main class="main-content">
  <section class="main-section">
    @if(upperImportedCards()){
    <div class="vy-card-image_wrapper">
      @for (card of upperImportedCards(); track $index) {
      <div class="vy-card-image_content">
        <vy-card-featured [cardFeaturedInfo]="card" (clickEventEmitter)="handleCardClick($event)"> </vy-card-featured>
      </div>
      }
    </div>
    } @if(lowerImportedCard()){
    <div class="vy-card-image_wrapper marginTop-l">
      @for (card of lowerImportedCard(); track $index) {
      <div class="vy-card-image_content">
        <vy-card-featured [cardFeaturedInfo]="card" (clickEventEmitter)="handleCardClick($event)"> </vy-card-featured>
      </div>
      }
    </div>
    }
  </section>
</main>
